import { render, staticRenderFns } from "./tenderCategory.vue?vue&type=template&id=a9772ae0"
import script from "./tenderCategory.vue?vue&type=script&lang=js"
export * from "./tenderCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports